import React, { useContext } from 'react';
import { RicosViewerContext, RicosNodeContext, RicosDirectionContext, RicosNodeContextProvider } from 'ricos-context';
import { i as indentStyle } from '../../../../indentation-a6da70c7.js';
import { r as rtlStyles } from '../../../../rtl.rtlignore-09de95fb.js';
import { indentLevelToClassName } from '../consts.js';
import classnames from 'classnames';
import Anchorable from '../../utils/Anchorable.js';
import { isPaywallSeo, getPaywallSeoClass } from '../../utils/paywallSeo.js';
import { getTextDirection } from 'wix-rich-content-common';
import { getTextDirectionFromAlignment } from 'ricos-converters';
import 'ricos-schema';

var styles = {"fontElementMap":"_7VgYW","quote":"_0RbUe"};

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const Blockquote = ({ node, nodeIndex, RicosNodesRenderer }) => {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i;
  const { seoMode } = useContext(RicosViewerContext);
  const { parentNode } = useContext(RicosNodeContext);
  const { textDirection } = useContext(RicosDirectionContext);
  const { indentation = 0 } = node.blockquoteData || {};
  const BlockquoteClassName = classnames(
    styles.quote,
    indentation > 0 && indentStyle[indentLevelToClassName[indentation]],
    rtlStyles[textDirection || getTextDirectionFromAlignment((_d = (_c = (_b = (_a = node.nodes) == null ? void 0 : _a[0]) == null ? void 0 : _b.paragraphData) == null ? void 0 : _c.textStyle) == null ? void 0 : _d.textAlignment) || getTextDirection((_i = (_h = (_g = (_f = (_e = node.nodes) == null ? void 0 : _e[0]) == null ? void 0 : _f.nodes) == null ? void 0 : _g[0]) == null ? void 0 : _h.textData) == null ? void 0 : _i.text) || "ltr"],
    !parentNode && isPaywallSeo(seoMode) && getPaywallSeoClass((seoMode == null ? void 0 : seoMode.paywall) || {}, nodeIndex)
  );
  const childClassName = styles.child;
  return /* @__PURE__ */ React.createElement(Anchorable, { nodeId: node.id }, /* @__PURE__ */ React.createElement("blockquote", { className: BlockquoteClassName }, /* @__PURE__ */ React.createElement("span", { className: childClassName }, /* @__PURE__ */ React.createElement(RicosNodeContextProvider, { parentNode: node, parentIndex: nodeIndex }, /* @__PURE__ */ React.createElement(RicosNodesRenderer, { nodes: node.nodes })))));
};
const BlockquoteRenderer = (_a) => {
  var _b = _a, { node } = _b, props = __objRest(_b, ["node"]);
  return /* @__PURE__ */ React.createElement(Blockquote, __spreadValues({ key: node.id, node }, props));
};

export { BlockquoteRenderer as default };
//# sourceMappingURL=blockquote.js.map
